import { IUsuario } from '@appNeo/neoCore/interfaces/IUsuario';

export const USUARIO_DEMO: IUsuario = {
    "id": "14",
    "login": "contactoMuyLargoCorreoMuyLargo@duacode.com",
    "nombre": "Martina",
    "apellidos": "Gómez Pérez",
    "email": "contactoMuyLargoCorreoMuyLargo@duacode.com",
    "direccion": "Calle Alfonso Molina 23 4º-A",
    "municipio": "A Coruña",
    "pais": "España",
    "cp": "15789",
    "teletrabajo": true,
    "telefono": "+34987454545",
    "idFacebook": null,
    "idTwitter": null,
    "idGoogle": null,
    "emailVerificado": true,
    "aceptaPublicidad": true,
    "rutaFoto": null,
    "fechaAlta": new Date(),
    "fechaNacimiento": new Date(),
    "fechaModificacion": new Date(),
    "idsDepartamentos": ['1', '2'],
    "observaciones": 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur',
    // "imagenListado": "http://htdocs.local/demo-neo-api-matrix/images/dc_modulos/admin/usuarios/_mini/listado/default.png?t=20211027172126",
    // "imagenPerfil": "http://htdocs.local/demo-neo-api-matrix/images/dc_modulos/admin/usuarios/_mini/perfil/default.png?t=20211027172126",
    // "imagen": "http://htdocs.local/demo-neo-api-matrix/images/dc_modulos/admin/usuarios/default.png?t=20211027172126",
    "rutaImagenPerfil": "assets/images/avatardemo.png",
    "avatar": {
      "nombre": "Administrador",
      "title": "5.jpg",
      "alt": "5.jpg",
      "ruta": "data/usuario/1/fichero/572/5.jpg",
      "rutaAbsoluta": "https://preproduccion.duacode.org/ocio-marineda/web-zona-fan/data/usuario/1/fichero/572/5.jpg",
      "idFichero": "572",
      "miniaturas": {
        "_mini/grid": "https://preproduccion.duacode.org/ocio-marineda/web-zona-fan/data/usuario/1/fichero/572/_mini/grid/5.jpg?t=20220712142642",
        "_mini/listado": "https://preproduccion.duacode.org/ocio-marineda/web-zona-fan/data/usuario/1/fichero/572/_mini/listado/5.jpg?t=20220712142642",
        "_mini/perfil": "https://preproduccion.duacode.org/ocio-marineda/web-zona-fan/data/usuario/1/fichero/572/_mini/perfil/5.jpg?t=20220712142642"
      }
      // "id": "1",
      // "nombre": "avatardemo.jpg",
      // "extension": ".jpg",
      // "peso": 2300,
      // "imagen": {
      //     "src": "assets/images/avatardemo.png"
      // }
   },
   "idEstado": '1',
    "usuarioEstadoActual": {
      "id": "1",
      "nombre": "Activo",
      "icono": "build",
      "color": "14AD66"
    },
  "roles": [],
  "permisos": []
}
